var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.emptyType === 'basic')?_c('p',{staticClass:"search-file-empty"},[_vm._v("해당 데이터가 없습니다.")]):(_vm.emptyType === 'recruit')?_c('p',{staticClass:"search-file-empty empty-comm"},[_vm._v("현재 진행중인 채용 공고가 없습니다.")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }